import { Evidence } from "@p0security/shared/types/evidence";

import { PermissionPreview } from "./PermissionPreview";

export const PreApprovalPreview: React.FC<{ preApproval: Evidence }> = ({
  preApproval,
}) => (
  <PermissionPreview
    requestor={[
      { type: "user", sub: preApproval.principal, role: "principal" },
    ]}
    verb="has pre-approved access to"
    permission={preApproval}
    reason={preApproval.reason}
    createdAt={preApproval.createdAt}
    approverDetail={preApproval.approver?.email}
  />
);
